export default {
      id: "pin-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#pin",
      toString: function () {
        return this.url;
      }
    }